module.exports = __webpack_public_path__ + "static/media/carta_43.658f8f69.jpg";